import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DialogContent from "@mui/material/DialogContent";

import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  ListItemText,
  Modal,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  TextField,
  styled,
  Dialog,
  DialogTitle,
} from "@mui/material";
import MuiMenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import DownloadIcon from "./../Assests/download.svg";
import UploadIcon from "./../Assests/upload.svg";
import DuplicateIcon from "./../Assests/duplicate-scenario.svg";
import EditScenario from "./../Assests/edit-scenario.svg";
import ReRun from "./../Assests/rerun-icon.svg";
import ReRun1 from "./../Assests/rerun-disabled.svg";

import excelIcon from "./../Assests/excel-icon.png";
import arrowIcon from "./../Assests/arrow-white.png";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import useMediaQuery from "@mui/material/useMediaQuery";

import InfoIcon from "@mui/icons-material/Info";
import EditIcon from "@mui/icons-material/Edit";

import UploadModal from "./Modals/UploadModal";
import CancelIcon from "@mui/icons-material/Close";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import * as actions from "./../Redux/Actions/index";
import {
  closeModal,
  goBack,
  cloaseDonePopup,
  openErrorDialog,
  displayScenarioList,
  displayScenarioListSuccess,
  displayScenarioListError,
  displayFolderList,
  displayFolderListError,
  displayFolderListSuccess,
  selectedScenarioListSuccess,
  selectedFolderListSuccess,
  displayDashboardSummaryCost,
  displayDashboardSummaryCostSuccess,
  displayDashboardSummaryCostError,
  displayMonthNamesListSuccess,
  selectedCategoryListSuccess,
  selectedUsecaseListSuccess,
  selectedTimePeriodSuccess,
  openErrorOrWarningDialog,
  nutritionDisplayDashboardSummaryCost,
  nutritionDisplayDashboardSummaryCostSuccess,
  nutritionDisplayDashboardSummaryCostError,
  enableEditFilter,
  fileUploadStatus,
  enableEditPopupForSave,
  selectedUploadFolderListSuccess,
  selectedFolderListError,
} from "./../Redux/Actions/InputData";
import DuplicateScenario from "./Modals/DuplicateScenario";
import BaseLineUploading from "./Modals/BaseLineUploading";
import DoneDialog from "./Modals/DoneDialog";
import ErrorDialog from "./Modals/ErrorDialog";
import _ from "underscore";
import "./style.css";
import { getRequest, putRequest } from "../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  DISPLAY_SCENARIO_FILTER_API,
  DISPLAY_SUMMARY_COST_DASHBOARD,
  NUTRITION_DISPLAY_SUMMARY_COST_DASHBOARD,
  // GET_SAS_URI_API,
  DOWNLOAD_GUROBI_API,
  DISPLAY_MONTH_NAMES_API,
  NUTRITION_DISPLAY_MONTH_NAMES_API,
  USECASE_DETAILS_API,
  CATEGORY_DETAILS_API,
  // DISPLAY_FOLDER_LIST_BY_USECASE_API,
  DISPLAY_FOLDER_LIST_BY_USECASE_AND_USERID_API,
  NUTRITION_DOWNLOAD_GUROBI_API,
  MEDIUM_DOWNLOAD_GUROBI_API,
  MEDIUM_DISPLAY_SUMMARY_COST_DASHBOARD,
  MEDIUM_NUTRITION_DISPLAY_SUMMARY_COST_DASHBOARD,
  NUTRITION_MEDIUM_DOWNLOAD_GUROBI_API,
  MEDIUM_HOME_DISPLAY_MONTH_NAMES_API,
  MEDIUM_NUTRITION_DISPLAY_MONTH_NAMES_API,
  SHORT_TERM_HOMECARE_API,
  RERUN_EDIT_HOMECARE_DETAILS_API,
  RERUN_EDIT_NUTRITION_DETAILS_API,
  RERUN_HOMECARE_DETAILS_API,
  RERUN_NUTRITION_DETAILS_API,
  PROGRESS_BAR_DETAILS_API,
  RERUN_PROGRESS_BAR_DETAILS_API,
  RERUN_MEDIUM_HOMECARE_DETAILS_API,
  RERUN_MEDIUM_NUTRITION_DETAILS_API,
  CGO_FOLDER_GET_API,
  CGO_SCENARIO_GET_API,
  CGO_GUROBI_DOWNLOAD_API,
  CGO_Location_EDIT_API,
  CGO_SUMMARY_COST_API,
  SELECTED_DISPLAY_FOLDER_API,
  RERUN_COG_DETAILS_API,
  RERUN_COG_PROGRESS_BAR_DETAILS_API,
} from "../Utils/Config";
import axios from "axios";
import FileSaver from "file-saver";
import { BlobServiceClient } from "@azure/storage-blob";
import ErrorOrWarningDialog from "./Modals/ErrorOrWarningDialog";
import ReplayIcon from "@mui/icons-material/Replay";
import Loader from "./Modals/Loader";
import SaveIcon from "@mui/icons-material/Save";
import CGOUploadMasterData from "./Modals/CGOUploadMasterData";
import ToastPopup from "./ToastPopup";
import { useTheme } from "@mui/material/styles";
import CGOInputModal from "./Modals/CgoInputModal";
import { ActivateOrDeactivateFolder } from "../Services/FolderService";

const MenuItem = styled(MuiMenuItem)(({ theme }) => ({
  "& .MuiSvgIcon-root": {
    marginRight: theme.spacing(1),
  },
}));
const BootstrapDialog = styled(Dialog)(({ theme }: any) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
function CGOFilterComponent(props: any) {
  const modelRef = useRef(null);
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const hiddenFileInput: any = React.useRef(null);
  const [isOpenUploadModal, setIsUploadModal] = useState(false);
  const [selectTimePeriod, setSelectTimePeriod] = useState<string[]>([
    "Time Period",
  ]);
  const [selectScenario, setSelectScenario] = useState<any>("Scenario");
  const [selectFolder, setSelectFolder] = useState<any>("Folder");
  const [selectUsecase, setSelectUsecase] = useState<any>("Use Case");
  const [selectCategory, setSelectCategory] = useState<any>("Category");
  const [sasUri, setSasUri] = useState("");
  const [reRun, setReRun] = useState("");
  const [openForEdit, setOpenForEdit] = React.useState(false);

  const [selectedUsecaseeId, setSelectedUsecaseId] = useState<any>(0);
  const [selectedScenarioId, setSelectedScenarioId] = useState<any>();
  const [selectedFolderId, setSelectedFolderId] = useState<any>();
  // const [selectedUploadFolderId, setselectedUploadFolderId] = useState<any>();
  const [selectedCategoryId, setSelectedCategoryId] = useState<any>(0);
  const [duplicateScenario, setDuplicateScenario] = useState<any>(false);
  const [isOpenBaseLineUploader, setIsOpenBaseLineUploader] = useState(false);
  const [isUploadMasterFile, setIsUploadMasterFile] = React.useState(false);
  const [isFileUploadStatus, setIsFileUploadStatus] = React.useState(false);
  const [isEditFileStatus, setIsEditFileStatus] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(true);
  const [isNext, setIsNext] = React.useState(false);
  const [selectRadio, setSelectRadio] = React.useState("");
  const [CGOFolderOptions, setCGOFolderOptions] = React.useState<any>([]);
  const [categoryOptions, setCategoryOptions] = useState<any>([]);
  const [folderOptions, setFolderOptions] = useState<any>([]);
  const [scenarioOptions, setScenarioOptions] = useState<any>([]);
  const [monthNameOptions, setMonthNamesOptions] = useState<any>([]);
  const [nutritionMonthNameOptions, setNutritionMonthNamesOptions] =
    useState<any>([]);

  const [selectedfile, setSelectedFile] = useState<any>({});
  const [selectedfileList, setSelectedFileList] = useState<any>([]);
  const [selectedItemId, setSelectedItemId] = useState("");
  const [uploadStatusData, setUploadStatusData] = useState<any>([]);
  const [rerunUploadStatusData, setRerunUploadStatusData] = useState<any>([]);
  const [reRunStatus, setReRunStatus] = useState<any>("");
  const [reRunSuccess, setReRunSuccess] = React.useState(false);
  const [uploadId, setUploadId] = React.useState("");

  const [CGOScenarioOptions, setCGOScenarioOptions] = useState<any>([]);

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId,
  );

  const selectedCategoryIdd = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId,
  );

  const sortedScenarioNames = scenarioOptions.sort((a: any, b: any) =>
    a?.scenario.localeCompare(b?.scenario),
  );

  const sortedFolderNames = CGOFolderOptions.sort((a: any, b: any) =>
    a?.folder.localeCompare(b?.folder),
  );
  const [isDownLoadDisable, setIsDownLoadDisable] = useState<any>(false);
  const [isUploadNowSuccess, setIsUploadNowSuccess] = useState(false);
  const homeMasterData: any = [
    {
      id: 1,
      name: "Upload COG file",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
      align: "left",
      headerAlign: "left",
    },
    // {
    //   id: 2,
    //   name: "Cascade Master*",
    //   btnName: "upload",
    //   selectedFile: {},
    //   ref: React.useRef(null),
    //   align: "left",
    //   headerAlign: "left",
    // },
    // {
    //   id: 3,
    //   name: "Facility Master*",
    //   btnName: "upload",
    //   selectedFile: {},
    //   ref: React.useRef(null),
    //   align: "left",
    //   headerAlign: "left",
    // },
    // {
    //   id: 4,
    //   name: "Shift & Changeover*",
    //   btnName: "upload",
    //   selectedFile: {},
    //   ref: React.useRef(null),
    //   align: "left",
    //   headerAlign: "left",
    // },
  ];

  const homeInputLine: any = [
    {
      id: 1,
      name: "Landed Cost*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 2,
      name: "OEE & CPT*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 3,
      name: "Demand*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 4,
      name: "Primary Transportation*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
  ];
  const nutritionMasterData: any = [
    {
      id: 1,
      name: "Facility Master*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 2,
      name: "Manufacturing Master*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 3,
      name: "BOM*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 4,
      name: "Packaging Master*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 5,
      name: "Cascade Master*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 6,
      name: "Shift & Changeover*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
  ];

  const nutritionInputLine = [
    {
      id: 1,
      name: "Minor Ingredient Landed Cost*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 2,
      name: "SFG Landed Cost*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 3,
      name: "Manufacturing OPE & CPT*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 4,
      name: "Packaging OEE & CPT*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 5,
      name: "Demand*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 6,
      name: "SFG transportation*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 7,
      name: "Primary Transportation*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
  ];

  const mediumHomeScenario: any = [
    {
      id: 1,
      name: "Landed Cost*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 2,
      name: "OEE & CPT*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 3,
      name: "Demand*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 4,
      name: "Primary Transportation*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 5,
      name: "Cascade Master(AddCap)*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 6,
      name: "Shift&Changeover(AddCap)*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 7,
      name: "ManufactureMaster&OEE(AddCap)*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
  ];
  const mediumNutritionScenario = [
    {
      id: 1,
      name: "Minor Ingredient Landed Cost*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 2,
      name: "SFG Landed Cost*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 3,
      name: "Manufacturing OPE & CPT*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 4,
      name: "Packaging OEE & CPT*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 5,
      name: "Demand*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 6,
      name: "SFG transportation*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 7,
      name: "Primary Transportation*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 8,
      name: "CascadeMaster(AddCap)*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 9,
      name: "ManfactureMasterandOPE(AddCap)*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 10,
      name: "PackagingMasterandOEE(AddCap)*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
    {
      id: 11,
      name: "ShiftandChangeover(AddCap)*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
  ];

  const masterData: any =
    selectedCategoryIdd !== 2 ? homeMasterData : nutritionMasterData;

  const isCreateFolder = useSelector(
    (state: any) => state.InputDataReducers.isCreateFolder,
  );

  const isUploadScenarioData = useSelector(
    (state: any) => state.InputDataReducers.isUploadScenario,
  );
  const isUploadBaseLineData = useSelector(
    (state: any) => state.InputDataReducers.isUploadBaseLineData,
  );

  const inputFolderValue = useSelector(
    (state: any) => state.InputDataReducers.inputFolderName,
  );

  const { scenarioData, isScenarioCreated } = useSelector(
    (state: any) => state.InputDataReducers,
  );

  const { dashboardSummaryCost, isDone, isLoading, uploadMasterFileMessage } =
    useSelector((state: any) => state.InputDataReducers);
  const isBaseLineUploader = useSelector(
    (state: any) => state.InputDataReducers.isBaseLineUploader,
  );
  const isFolderCreated = useSelector(
    (state: any) => state.InputDataReducers.isFolderCreated,
  );

  const uploadFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedUpload,
  );

  const selectedTimePeriodData = useSelector(
    (state: any) => state.InputDataReducers.selectedTimePeriodData,
  );

  /**Redux state */
  const uploadSelectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedUploadFolderId,
  );

  const isFileUpload = useSelector(
    (state: any) => state.InputDataReducers.fileUploadStatus,
  );

  const { isFolderSelected, folderSelectionMessage } = useSelector(
    (state: any) => state.InputDataReducers,
  );

  const uploadScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedUploadScenarioId,
  );
  const {
    isErrorDialog,
    errorMessage,
    isErrorOrWarningDialog,
    errorOrWarningMessage,
  } = useSelector((state: any) => state.InputDataReducers);

  const isDuplicateScenarioCreated = useSelector(
    (state: any) => state.InputDataReducers.isDuplicateScenarioCreated,
  );

  //const inputLine: any = selectedCategoryIdd !== 2 ? homeInputLine : nutritionInputLine;
  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable,
  );

  const [canEditScenario, setCanEditScenario] = useState(false);

  // suren
  const [showFullOverlay, setfullOverlayDetails] = useState(false);

  var inputLine: any;
  useEffect(() => {
    if (selectedUsecaseId === 1) {
      if (selectedCategoryIdd === 1) {
        setGetInputLineData(homeInputLine);
      } else {
        setGetInputLineData(nutritionInputLine);
      }
    } else {
      if (selectedCategoryIdd === 2) {
        if (isUploadScenarioData) {
          setGetInputLineData(mediumNutritionScenario);
        } else {
          setGetInputLineData(nutritionInputLine);
        }
      } else {
        if (isUploadScenarioData) {
          setGetInputLineData(mediumHomeScenario);
        } else {
          setGetInputLineData(homeInputLine);
        }
        // setGetInputLineData(isUploadScenarioData ? mediumHomeScenario : homeInputLine);
      }
    }
  }, [selectedUsecaseId, selectedCategoryIdd, isUploadScenarioData]);

  const [getMasterData, setGetMasterData] = useState(masterData);
  const [getInputLineData, setGetInputLineData] = useState(inputLine);

  const [selectedfilesList, setSelectedFilesList] = useState<any>([]);
  const [isUploadReady, setIsUploadReady] = useState<any>(false);
  const [openEditDialog, setOpenEditDialog] = useState<any>(false);
  const [openReRunDialog, setOpenReRunDialog] = useState<any>(false);
  const [uploadReRunStatus, setUploadReRunStatus] = useState<any>(false);
  const [openReRunDialogStatus, setOpenReRunDialogStatus] = useState<any>("");
  const [reRunDialogStatus, setReRunDialogStatus] = useState<any>("");
  const [fileTypeName, setFileTypeName] = useState<any>("");
  const [folderResponseData, setFolderResponseData] = useState<any>([]);
  const [isScenarioSelected, setIsScenarioSelected] = useState<any>(false);
  const [loader, setLoader] = useState<any>(false);

  useEffect(() => {}, []);

  useEffect(() => {
    if (
      selectedFolderId !== undefined &&
      selectedFolderId !== 0 &&
      selectedFolderId !== ""
    ) {
      if (selectedUsecaseId === 1) {
        if (selectedCategoryId === 1) {
          callMonthFilterApi(selectedScenarioId);
        } else {
          nutritionCallMonthFilterApi(selectedScenarioId);
        }
      } else {
        if (selectedCategoryId === 1) {
          mediumHomecallMonthFilterApi(selectedScenarioId);
        } else {
          mediumNutritionCallMonthFilterApi(selectedScenarioId);
        }
      }
    }
  }, [selectedScenarioId]);

  useEffect(() => {
    if (
      selectedFolderId !== undefined &&
      selectedFolderId !== 0 &&
      selectedFolderId !== ""
    ) {
      callScenarioFilterApi({ id: selectedFolderId });
    }
  }, [isDuplicateScenarioCreated, isScenarioCreated]);

  useEffect(() => {
    const urls = API_BASE_URL + DISPLAY_FOLDER_LIST_BY_USECASE_AND_USERID_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      { useCase: 4, category: 0, createdBy: userData.userId },
      header,
    )
      .then((response) => {
        if (response.status === 200 && response.data) {
          let responseArray = [];
          responseArray.push(response.data?.data);
          setCGOFolderOptions(response.data?.data);
          dispatch(displayScenarioListSuccess(response.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayScenarioListError(error.message));
      });
  }, []);

  useEffect(() => {
    const urls = API_BASE_URL + CATEGORY_DETAILS_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(urls, {}, header)
      .then((response) => {
        if (response.status === 200 && response.data) {
          setCategoryOptions(response.data);
          dispatch(displayScenarioListSuccess(response.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayScenarioListError(error.message));
      });
  }, []);

  var mainStatus = false;

  const callFolderFilterApi = (useCaseId: number, categoryId: number) => {
    dispatch(displayFolderList());
    const urls = API_BASE_URL + DISPLAY_FOLDER_LIST_BY_USECASE_AND_USERID_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      { useCase: useCaseId, category: categoryId, createdBy: userData.userId },
      header,
    )
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setFolderOptions(response.data.data);
          dispatch(displayFolderListSuccess(response.data.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayFolderListError(error.message));
      });
  };

  const getSummaryCostForDashboard = (folderId: any, scenarioId: any) => {
    dispatch(displayDashboardSummaryCost());
    const urls = API_BASE_URL + DISPLAY_SUMMARY_COST_DASHBOARD;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseeId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        scenario_id: scenarioId,
      },
      header,
    )
      .then((response) => {
        // if (response.status === 200 && response.data.success) {
        //   setFolderOptions(response.data.data);
        dispatch(displayDashboardSummaryCostSuccess(response.data));
        // }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(displayDashboardSummaryCostError(error.message));
      });
  };

  const nutritionGetSummaryCostForDashboard = (
    folderId: any,
    scenarioId: any,
  ) => {
    dispatch(nutritionDisplayDashboardSummaryCost());
    const urls = API_BASE_URL + NUTRITION_DISPLAY_SUMMARY_COST_DASHBOARD;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseeId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        scenario_id: scenarioId,
      },
      header,
    )
      .then((response) => {
        dispatch(nutritionDisplayDashboardSummaryCostSuccess(response?.data));
        // }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(nutritionDisplayDashboardSummaryCostError(error.message));
      });
  };

  const MediumgetSummaryCostForDashboard = (folderId: any, scenarioId: any) => {
    dispatch(displayDashboardSummaryCost());
    const urls = API_BASE_URL + MEDIUM_DISPLAY_SUMMARY_COST_DASHBOARD;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseeId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        scenario_id: scenarioId,
      },
      header,
    )
      .then((response) => {
        // if (response.status === 200 && response.data.success) {
        //   setFolderOptions(response.data.data);
        dispatch(displayDashboardSummaryCostSuccess(response.data));
        // }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(displayDashboardSummaryCostError(error.message));
      });
  };

  const MediumnutritionGetSummaryCostForDashboard = (
    folderId: any,
    scenarioId: any,
  ) => {
    dispatch(nutritionDisplayDashboardSummaryCost());
    const urls = API_BASE_URL + MEDIUM_NUTRITION_DISPLAY_SUMMARY_COST_DASHBOARD;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseeId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        scenario_id: scenarioId,
      },
      header,
    )
      .then((response) => {
        dispatch(nutritionDisplayDashboardSummaryCostSuccess(response?.data));
        // }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(nutritionDisplayDashboardSummaryCostError(error.message));
      });
  };

  const handleUploadFile = (e: any, item: any, index: number) => {
    e.preventDefault();
    //hiddenFileInput.current.click();
    if (selectRadio === "inputData") {
      getInputLineData[index]?.ref.current.click();
      // e.target.value = null;
      clearInterval(getInputLineData[index].ref.current);
      //hiddenFileInput.current = null;
      // getInputLineData[index].ref.current = null;
      setSelectedItemId(item.id);
    } else {
      getMasterData[index]?.ref?.current?.click();
      // e.target.value = null;
      clearInterval(getMasterData[index]?.ref.current);
      //hiddenFileInput.current = null;
      // getMasterData[index].ref.current = null;
      setSelectedItemId(item.id);
    }
  };

  const handleChangeFileUpload = (e: any) => {
    selectedfileList.length = 0;
    const fileUploaded = e.target.files[0];
    selectedfileList.push(fileUploaded.name);
    selectedfilesList.push({
      filename: fileUploaded.name,
      filedata: fileUploaded,
    });
    if (!fileUploaded) {
      return;
    }
    if (selectRadio === "inputData") {
      const newArr = getInputLineData.map((ele: any, i: any) => {
        if (selectedItemId === ele.id) {
          ele.selectedFile = fileUploaded;
        }
        return ele;
      });
      setGetMasterData(newArr);
    } else {
      const newArr = getMasterData.map((ele: any, i: any) => {
        if (selectedItemId === ele.id) {
          ele.selectedFile = fileUploaded;
        }
        return ele;
      });
      setGetMasterData(newArr);
    }
    setSelectedFile(fileUploaded);
  };

  const handleCancelFile = (e: any, elem: any) => {
    if (selectRadio === "inputData") {
      const newArr = getInputLineData?.filter((ele: any, i: any) => {
        if (ele.id === elem.id) {
          ele.selectedFile = {};
        }
        return ele;
      });
      setGetMasterData(newArr);
    } else {
      const newArr = getMasterData?.filter((ele: any, i: any) => {
        if (ele.id === elem.id) {
          ele.selectedFile = {};
        }
        return ele;
      });
      setGetMasterData(newArr);
    }
  };

  const callScenarioFilterApi = (params: any) => {
    dispatch(displayScenarioList());
    const urls = API_BASE_URL + CGO_SCENARIO_GET_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      { folder_id: params.id, createdBy: userData.userId },
      header,
    )
      .then((response) => {
        if (response.status === 200 && response.data) {
          let responseArray = [];
          //responseArray.push(response.data);
          //
          setScenarioOptions(response.data);
          dispatch(displayScenarioListSuccess(response.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayScenarioListError(error.message));
      });
  };

  const callMonthFilterApi = (scenarioId: number) => {
    dispatch(displayScenarioList());
    const urls = API_BASE_URL + DISPLAY_MONTH_NAMES_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };

    getRequest(
      urls,
      {
        usecase_id: selectedUsecaseeId,
        category_id: selectedCategoryId,
        folder_id: selectedFolderId,
        scenario_id: scenarioId,
      },
      header,
    )
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setMonthNamesOptions(response.data.data);
          dispatch(displayMonthNamesListSuccess(response.data.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayScenarioListError(error.message));
      });
  };

  const nutritionCallMonthFilterApi = (scenarioId: number) => {
    dispatch(displayScenarioList());
    const urls = API_BASE_URL + NUTRITION_DISPLAY_MONTH_NAMES_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };

    getRequest(
      urls,
      {
        usecase_id: selectedUsecaseeId,
        category_id: selectedCategoryId,
        folder_id: selectedFolderId,
        scenario_id: scenarioId,
      },
      header,
    )
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          // let responseArray = [];
          // responseArray.push(response.data);
          // setMonthNamesOptions(response.data);
          // dispatch(displayMonthNamesListSuccess(response.data));
          setNutritionMonthNamesOptions(response.data.data);
          dispatch(displayMonthNamesListSuccess(response.data.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayScenarioListError(error.message));
      });
  };

  const mediumHomecallMonthFilterApi = (scenarioId: number) => {
    dispatch(displayScenarioList());
    const urls = API_BASE_URL + MEDIUM_HOME_DISPLAY_MONTH_NAMES_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };

    getRequest(
      urls,
      {
        usecase_id: selectedUsecaseeId,
        category_id: selectedCategoryId,
        folder_id: selectedFolderId,
        scenario_id: scenarioId,
      },
      header,
    )
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setMonthNamesOptions(response.data.data);
          dispatch(displayMonthNamesListSuccess(response.data.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayScenarioListError(error.message));
      });
  };

  const mediumNutritionCallMonthFilterApi = (scenarioId: number) => {
    dispatch(displayScenarioList());
    const urls = API_BASE_URL + MEDIUM_NUTRITION_DISPLAY_MONTH_NAMES_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };

    getRequest(
      urls,
      {
        usecase_id: selectedUsecaseeId,
        category_id: selectedCategoryId,
        folder_id: selectedFolderId,
        scenario_id: scenarioId,
      },
      header,
    )
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          // let responseArray = [];
          // responseArray.push(response.data);
          // setMonthNamesOptions(response.data);
          // dispatch(displayMonthNamesListSuccess(response.data));
          setNutritionMonthNamesOptions(response.data.data);
          dispatch(displayMonthNamesListSuccess(response.data.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayScenarioListError(error.message));
      });
  };

  const handleChangeRadio = (e: any) => {
    e.preventDefault();
    const value = e.target.value;
    setUploadStatusData([]);
    setRerunUploadStatusData([]);
    setSelectRadio(value);
    if (value === "masterData") {
      setGetMasterData(masterData);
    } else {
      setGetMasterData(inputLine);
    }
  };

  const handleGurobiDownload = () => {
    if (selectedScenarioId > 0) {
      downloadGurobiFile();
    } else {
      //setIsDownLoadDisable(true);
      dispatch(openErrorOrWarningDialog("Please select atleast one Scenario."));
    }
  };

  const downloadGurobiFile = async () => {
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
    };
    const urls = API_BASE_URL + CGO_GUROBI_DOWNLOAD_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      //FileSaver(blob, Date.now() + '.xlsx');
      FileSaver(blob, "Optimized Output.xlsx");
    });
  };

  const nutritionDownloadGurobiFile = async () => {
    const requestParam = {
      usecaseId: selectedUsecaseeId,
      category_Id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
    };
    const urls = API_BASE_URL + NUTRITION_DOWNLOAD_GUROBI_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      //FileSaver(blob, Date.now() + '.xlsx');
      FileSaver(blob, "Nutrition Optimized Output.xlsx");
    });
  };

  const [scenarioCost, setScenarioCost] = useState("");
  const [scenarioAnalysys, setScenarioAnalysys] = useState(false);
  const handleChangeSelectScenario = (event: any) => {
    setIsScenarioSelected(true);
    const {
      target: { value },
    } = event;
    setScenarioAnalysys(value?.isAnalysis);
    setPotentialValue(value?.potentialLocations);
    setSelectScenario(value.scenario);
    setIsFileUploadStatus(false);
    setCanEditScenario(value.canEdit);
    setSelectedScenarioId(value.scenario_id);
    dispatch(selectedScenarioListSuccess(value));
    const urls = API_BASE_URL + CGO_SUMMARY_COST_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        folder_id: selectedFolderId,
        scenario_id: value.scenario_id,
      },
      header,
    )
      .then((response) => {
        if (response.status === 200) {
          setScenarioCost(response?.data?.bestScenarioCost);
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayScenarioListError(error.message));
      });
  };

  const handleChangeSelectFolder = (event: any) => {
    setCanEditScenario(false);
    if (isEditEnabled === false || isEditEnabled === undefined) {
      const {
        target: { value },
      } = event;
      setSelectFolder(value.folder);
      CGOScenarioFilterApi(value.id);
      setSelectedFolderId(value.id);
      dispatch(selectedFolderListSuccess(value));
    } else {
      setIsEditFileStatus(true);
    }
    setSelectScenario("Scenario");
  };

  const handleClickSelectFolder = (event: any) => {
    // dispatch(
    //   openErrorOrWarningDialog(
    //     "Please select atleast one Folder"
    //   )
    // );
  };

  const CGOScenarioFilterApi = (folderId: number) => {
    dispatch(displayScenarioList());
    const urls = API_BASE_URL + CGO_SCENARIO_GET_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        folder_id: folderId,
        createdBy: userData.userId,
      },
      header,
    )
      .then((response) => {
        if (response.status === 200) {
          console.log(response.data, "responseee");
          setCGOScenarioOptions(response.data);
          setFolderResponseData(response?.data);
          // setCanEditScenario(response?.data.)
          // dispatch(displayMonthNamesListSuccess(response.data.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayScenarioListError(error.message));
      });
  };

  const handleClickSelectScenario = (event: any) => {
    setIsScenarioSelected(true);
    if (selectedFolderId === undefined || selectedFolderId === 0) {
      //setPageIsLoaded(true);
      //setPageIsDefaultLoaded(true);
      //dispatch(openErrorDialog("Default"));
      dispatch(
        openErrorOrWarningDialog(
          "Please select atleast one usecase, category and folder.",
        ),
      );
    } else {
      //setPageIsLoaded(false);
      //setPageIsDefaultLoaded(false);
    }
  };

  const setInitialValues = () => {
    setSelectFolder("Folder");
    setSelectedFolderId("");
    setSelectedScenarioId("");
    dispatch(selectedTimePeriodSuccess([]));
    dispatch(selectedFolderListSuccess(0));
    dispatch(selectedScenarioListSuccess(0));
    setScenarioOptions([]);
    setMonthNamesOptions([]);
    setSelectScenario("Scenario");
    setSelectTimePeriod(["Time Period"]);
  };
  const handleChangeUsecase = (event: any) => {
    if (isEditEnabled === false || isEditEnabled === undefined) {
      const {
        target: { value },
      } = event;
      setSelectUsecase(value.name);
      setSelectedUsecaseId(value.id);
      setIsFileUploadStatus(false);
      dispatch(selectedUsecaseListSuccess(value));
      if (value.id !== 0) {
        callFolderFilterApi(value.id, selectedCategoryId);
      }
      setInitialValues();
    } else {
      setIsEditFileStatus(true);
    }
  };

  const handleChangeCategory = (event: any) => {
    if (isEditEnabled === false || isEditEnabled === undefined) {
      const {
        target: { value },
      } = event;

      setSelectCategory(value.name);
      setIsFileUploadStatus(false);
      setSelectedCategoryId(value.id);
      dispatch(selectedCategoryListSuccess(value));
      setInitialValues();
      if (selectedUsecaseeId !== 0) {
        callFolderFilterApi(selectedUsecaseeId, value.id);
      }
      // setIsEdit(!isEdit);
      dispatch(enableEditFilter(false, "handlecat"));
    } else {
      setIsEditFileStatus(true);
    }
  };

  const [isUplodNowPopup, setIsUploadNowPopup] = useState(false);
  const handleUploadData = () => {
    // Check if this is a "view existing scenario" flow
    // Get the flag from localStorage or props
    const viewExistingFlag = localStorage.getItem("viewExistingScenario");

    if (viewExistingFlag === "true") {
      // Set view existing scenario mode
      setIsViewExistingScenario(true);
      setModalTitleText("Upload Data - Selected Scenario");
    } else {
      // Normal flow - select/create folder
      setIsViewExistingScenario(false);
      setModalTitleText("Select/Create Folder & Add Scenario");
    }

    setIsUploadNowPopup(true);
    // setIsUploadNowPopup(true);
  };

  //close modal when click on closs button
  const closeUploadModal = () => {
    setIsUploadNowPopup(false);
    // dispatch(selectedUsecaseListSuccess(selectedUsecaseeId));
    // dispatch(selectedCategoryListSuccess(selectedCategoryId));
    setIsUploadModal(false);
    setIsNext(false);
    // setGetMasterData(masterData);
    setGetInputLineData((previousData: any) => previousData);
    setSelectRadio("");
    setSelectedFile({});
    setIsUploadMasterFile(false);
    dispatch(closeModal());
    dispatch(selectedUsecaseListSuccess(selectedUsecaseeId));
    dispatch(selectedCategoryListSuccess(selectedCategoryId));
    dispatch(selectedFolderListSuccess(selectedFolderId));
    dispatch(selectedScenarioListSuccess(selectedScenarioId));
    dispatch(displayDashboardSummaryCostSuccess(dashboardSummaryCost));
  };

  const handleOpenDuplicateScenario = () => {
    setDuplicateScenario(true);
    // if (
    //   selectedUsecaseeId !== undefined &&
    //   selectedUsecaseeId !== 0 &&
    //   selectedCategoryId !== undefined &&
    //   selectedCategoryId !== 0
    // ) {
    //   dispatch(selectedUsecaseListSuccess(selectedUsecaseeId))
    //   dispatch(selectedCategoryListSuccess(selectedCategoryId))
    //   //setPageIsLoaded(false);

    //   dispatch(selectedUsecaseListSuccess(selectedUsecaseeId))
    //   dispatch(selectedCategoryListSuccess(selectedCategoryId))
    // } else {
    //   //setPageIsLoaded(true);
    //   //dispatch(openErrorDialog("Default"));
    //   dispatch(
    //     openErrorOrWarningDialog(
    //       'Please select atleast one usecase and category'
    //     )
    //   )
    // }
  };

  const cancelDuplicate = () => {
    setDuplicateScenario(false);
  };

  const handleOpenBaseLineUploader = () => {
    setIsOpenBaseLineUploader(true);
  };

  const closeBaseLineUploader = () => {
    setIsOpenBaseLineUploader(false);
  };

  const handleCloseDonePopup = () => {
    setIsNext(false);
    setIsUploadMasterFile(false);
    dispatch(cloaseDonePopup());
    if (selectRadio === "inputData") {
      const newArr = getInputLineData.filter((ele: any, i: any) => {
        if (ele.id === selectedItemId) {
          ele.selectedFile = {};
        }
        return ele;
      });
      setGetInputLineData(newArr);
    } else {
      const newArr = getMasterData.filter((ele: any, i: any) => {
        if (ele.id === selectedItemId) {
          ele.selectedFile = {};
        }
        return ele;
      });
      setGetMasterData(newArr);
    }
    dispatch(selectedUsecaseListSuccess(selectedUsecaseeId));
    dispatch(selectedCategoryListSuccess(selectedCategoryId));
    dispatch(selectedFolderListSuccess(selectedFolderId));
    dispatch(selectedScenarioListSuccess(selectedScenarioId));
  };

  const [intervalId, setIntervalId] = useState<any>(null);
  let statusCount = 0;
  let processingCount = 0;
  let failedCount = 0;
  let gurobiCount = 0;
  const [loading, setLoading] = useState(false);
  const [reRunloading, setReRunLoading] = useState(false);
  const selected_folder_id =
    selectedFolderId !== "" ? selectedFolderId : uploadSelectedFolderId;

  const handleOpenApicall = (urls: any, requestParam: any) => {
    axios({
      url: urls,
      method: "post",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      if (response.status === 200) {
        setUploadStatusData(response.data);
      }
    });
  };

  const handleOpen = () => {
    setOpen(true);
    setUploadStatusData([]);
    setOpenReRunDialogStatus("");
    if (Number(selected_folder_id) > 0) {
      const requestParam = {
        usecaseId: selectedUsecaseeId,
        category_Id: selectedCategoryId,
        folder_id:
          uploadSelectedFolderId !== ""
            ? uploadSelectedFolderId
            : selectedFolderId,
        scenario_id: uploadScenarioId === 0 ? scenario_id : uploadScenarioId,
      };

      setLoading(true);
      const urls = API_BASE_URL + PROGRESS_BAR_DETAILS_API;
      const apicallInterval = setInterval(() => {
        handleOpenApicall(urls, requestParam);
      }, 5000);
      setIntervalId(apicallInterval);
    }
  };

  useEffect(() => {
    setOpenReRunDialogStatus("");
    if (isDone) {
      let isScenarioData = false;
      {
        uploadStatusData.map((item: any) => {
          item.status.includes("Gurobi")
            ? (isScenarioData = true)
            : (isScenarioData = false);
        });
      }
      {
        uploadStatusData.map((item: any) => {
          var statusstring = item.status;
          if (
            statusstring.includes("Master Successfully Completed") &&
            !isScenarioData
          ) {
            statusCount++;
            setLoading(false);
            if (intervalId !== null) {
              clearInterval(intervalId);
            }
          }
          if (statusstring.includes("Gurobi Successfully Completed")) {
            gurobiCount++;
            statusCount = 0;
            setLoading(false);
            if (intervalId !== null) {
              clearInterval(intervalId);
            }
          }
          if (statusstring?.toLowerCase().includes("processing")) {
            processingCount++;
          }
          if (statusstring?.toLowerCase().includes("failed")) {
            failedCount++;
            processingCount = 0;
            statusCount = 0;
            setLoading(false);
            if (intervalId !== null) {
              clearInterval(intervalId);
            }
          }
        });
      }

      if (uploadStatusData.length > 0 && gurobiCount > 0 && failedCount === 0) {
        setOpenReRunDialogStatus("Gurobi Data uploaded successfully!");
        if (intervalId !== null) {
          clearInterval(intervalId);
        }
      }
      if (uploadStatusData.length > 0 && statusCount > 0 && failedCount === 0) {
        setOpenReRunDialogStatus("Data uploaded successfully!");
        if (intervalId !== null) {
          clearInterval(intervalId);
        }
      }
      if (processingCount > 0) {
        setOpenReRunDialogStatus("Data upload in Progress");
      }
      if (failedCount > 0) {
        setOpenReRunDialogStatus("Data upload Failed");
        ActivateOrDeactivateFolder(selectedUsecaseId, selectedFolderId, 0);
        if (intervalId !== null) {
          clearInterval(intervalId);
        }
      }
    }
  }, [isDone, uploadStatusData]);

  const handleEdit = () => {
    if (selectedFolderId > 0) {
      dispatch(enableEditFilter(false, "handleedit"));

      setIsEdit(!isEdit);
      setOpenForEdit(true);
    }
    handleOpenCloseEditDialog();
  };

  let reRunIntervalId: any;
  const rerunApiCall = (urls: any, requestParam: any) => {
    axios({
      url: urls,
      method: "post",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    })
      .then((response) => {
        if (response?.status === 200) {
          setRerunUploadStatusData(response?.data);
          clearInterval(reRunIntervalId);
        } else {
          console.log(response, "errorDataS");

          // dispatch(enableEditFilter(false, 'handlecat'));
          //setReRunStatus("Rerun failed");
        }
      })
      .catch((e) => {
        clearInterval(reRunIntervalId);
      });
  };

  const handleRerunData = () => {
    const interval = setInterval(() => {
      const requestParam = {
        usecaseId: 0,
        category_id: 0,
        folder_id: selectedFolderId,
        scenario_id: selectedScenarioId,
      };
      setReRunLoading(true);
      setUploadReRunStatus(true);
      const urls = API_BASE_URL + RERUN_COG_PROGRESS_BAR_DETAILS_API;

      // const urls = API_BASE_URL + RERUN_HOMECARE_DETAILS_API;
      axios({
        url: urls,
        method: "post",
        headers: { "Content-Type": "application/json;" },
        data: requestParam,
      }).then((response) => {
        // if (response?.data?.toLowerCase() === "success") {
        setRerunUploadStatusData(response?.data);
        // }
      });
    }, 5000);
    setIntervalId(interval);
  };

  const handleRerun = (e: any) => {
    setOpenReRunDialogStatus("");
    dispatch(enableEditPopupForSave(false));

    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
    };
    const urls = API_BASE_URL + RERUN_COG_DETAILS_API;

    // const urls = API_BASE_URL + RERUN_HOMECARE_DETAILS_API;
    axios({
      url: urls,
      method: "post",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    })
      .then((response) => {
        if (response?.data?.toLowerCase() === "success") {
          //handleOpenReRunDialog();
          dispatch(enableEditFilter(false, "handlecat"));
          // setReRunStatus("Rerun Done Successfully")
          // handleUploadNow(e, "rerun");
          setReRunSuccess(true);
          handleRerunData();
        } else {
          handleOpenReRunDialog();
          dispatch(enableEditFilter(false, "handlecat"));
          setReRunStatus(
            "Module run is unsuccessful. Please connect with Darshan (darshan.gosalia@unilever.com) for assistance",
          );
          //handleRerunData();
        }
        // let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        //FileSaver(blob, Date.now() + '.xlsx');
        // FileSaver(blob, 'Optimized Output.xlsx');
      })
      .catch((err) => {
        handleOpenReRunDialog();
        dispatch(enableEditFilter(false, "handlecat"));
        setReRunStatus(
          "Module run is unsuccessful. Please connect with Darshan (darshan.gosalia@unilever.com) for assistance",
        );
        //handleRerunData();
      });
  };

  let statusCountReRun = 0;
  let processingCountReRun = 0;
  let failedCountReRun = 0;
  useEffect(() => {
    if (reRunSuccess) {
      rerunUploadStatusData.map((item: any) => {
        var statusstring = item.status;
        if (statusstring?.toLowerCase().includes("successfully")) {
          statusCountReRun++;
          if (intervalId !== null) {
            clearInterval(intervalId);
          }
        }
        if (statusstring?.toLowerCase().includes("Processing")) {
          processingCountReRun++;
        }
        if (statusstring?.toLowerCase().includes("failed")) {
          failedCountReRun++;
          if (intervalId !== null) {
            clearInterval(intervalId);
          }
        }
      });
    }
    if (
      rerunUploadStatusData.length > 0 &&
      statusCountReRun === rerunUploadStatusData.length
    ) {
      setReRunDialogStatus("Data uploaded successfully!");

      if (intervalId !== null) {
        clearInterval(intervalId);
      }
      setReRunLoading(false);
    }

    if (failedCountReRun > 0) {
      setReRunDialogStatus("Data upload Failed");
      if (intervalId !== null) {
        clearInterval(intervalId);
      }
      setReRunLoading(false);
    }
  }, [rerunUploadStatusData]);

  const handleUploadNow = (e: any, type: string) => {
    setIsFileUploadStatus(true);
    e.preventDefault();
    let formData = new FormData();
    if (selectRadio === "inputData") {
      getInputLineData.map((itm: any) => {
        if (!_.isEmpty(itm.selectedFile.name)) {
          formData.append("files", itm.selectedFile);
        }
      });
    } else {
      getMasterData.map((itm: any) => {
        if (!_.isEmpty(itm.selectedFile.name)) {
          formData.append("files", itm.selectedFile);
        }
      });
    }

    let filesList = selectedfilesList;
    let initialValues = {
      usecase: selectedUsecaseeId,
      category: selectedCategoryId,
      folder:
        uploadSelectedFolderId !== ""
          ? uploadSelectedFolderId
          : selectedFolderId,
      scenario: uploadScenarioId,
    };

    let fileType = "";
    if (selectRadio === "inputData" && scenarioData?.type === "scenario") {
      fileType = "scenario";
    } else if (selectRadio === "inputData") {
      fileType = "baseline";
    } else {
      fileType = "master";
    }
    setFileTypeName(fileType);

    // Directly dispatch the action, no GET_SAS_URI_API call
    dispatch(
      actions.onInitUloadMasterFile(
        formData,
        filesList,
        fileType,
        initialValues,
        type,
        "",
        "shorttermcog",
        userData?.userId,
      ),
    );
    setSelectedFilesList([]);
    handleOpen();

    // if (selectRadio === "inputData" && isCreateFolder && isUploadBaseLineData) {
    //   //dispatch(actions.onInitBaseLineUpload(formData, inputFolderValue));

    //   getSasUrlApi("baseline");
    //   setFileTypeName("baseline");
    // } else if (
    //   selectRadio === "inputData" &&
    //   scenarioData?.type === "scenario" &&
    //   isScenarioCreated
    // ) {
    //   //dispatch(actions.onInitScenarioLineUpload(formData, scenarioData));
    //   getSasUrlApi("scenario");
    //   setFileTypeName("scenario");
    // } else {
    //   let fileType = "";
    //   if (selectRadio === "inputData" && scenarioData?.type === "scenario") {
    //     fileType = "scenario";
    //   } else if (selectRadio === "inputData") {
    //     fileType = "baseline";
    //   } else {
    //     fileType = "master";
    //   }
    //   getSasUrlApi(fileType);
    //   setFileTypeName(fileType);
    // }
    setIsUploadMasterFile(true);

    // dispatch(fileUploadStatus(true));
  };

  const handleGoBack = () => {
    dispatch(goBack());
    setIsNext(false);
  };

  const handleNext = (e: any) => {
    e.preventDefault();
    // if (selectedCategoryId > 0 && selectedUsecaseeId) {
    setIsNext(true);
    // }
  };

  const handleBack = (e: any) => {
    e.preventDefault();
    setIsNext(false);
    dispatch(closeModal());
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const [open, setOpen] = React.useState(false);

  const scenarioNumber = useSelector(
    (state: any) => state.InputDataReducers.scenarioNumber,
  );

  const userData = useSelector(
    (state: any) => state.InputDataReducers.apiUserData,
  );

  var scenario_id = "";
  if (selectedScenarioId === "" || selectedScenarioId === 0) {
    scenario_id = scenarioNumber;
  } else {
    scenario_id = selectedScenarioId;
  }

  const handleClose = () => {
    setOpen(false);
  };

  // close uploading  file popup
  useEffect(() => {
    if (isDone) {
      setIsUploadMasterFile(false);
      // dispatch(selectBaseLineCost());
      setIsUploadModal(false);
      //closeUploadModal();
      // dispatch(selectedUsecaseListSuccess(selectedUsecaseeId));
      // dispatch(selectedCategoryListSuccess(selectedCategoryId));
    }
  }, [isDone, isFolderCreated]);

  useEffect(() => {
    if (selectedUsecaseeId !== 0) {
      callFolderFilterApi(selectedUsecaseeId, selectedCategoryId);
    }
  }, [isFolderCreated]);

  useEffect(() => {
    let uc = localStorage.getItem("selectedUsecase");
    let sr = localStorage.getItem("selectedRadio");
    let ucid = uc == "Short Term" ? 1 : 2;
    let srid = sr == "masterData" ? 1 : 2;
    setTimeout(() => {
      let e1 = {
        target: {
          value: {
            name: uc,
            id: ucid,
          },
        },
      };
      handleChangeUsecase(e1);
      let e2 = {
        target: {
          value: {
            name:
              sr === "masterData"
                ? "Integrated Processing and Packaging Facility"
                : "Separate Processing and Packaging Facilities",
            id: srid,
          },
        },
      };
      handleChangeCategory(e2);
    }, 1000);
  }, []);

  const handleCloseReRunStatus = () => {
    setOpenEditDialog(false);
  };

  const handleReRunDialog = () => {
    setIsEditFileStatus(false);
  };

  const handleReRunDialogStatus = () => {
    setUploadReRunStatus(false);
  };

  const handleBackDropClick = (e: any) => {
    if (modelRef.current === e.target) {
      e?.stopPropagation();
    }
  };

  const handleReRunSuccess = () => {
    setIsEditFileStatus(false);
  };
  const handleOpenCloseEditDialog = () => {
    setOpenEditDialog(true);
  };

  const handleCloseReRunDialog = () => {
    setOpenReRunDialog(false);
  };

  const handleOpenReRunDialog = () => {
    setOpenReRunDialog(true);
  };

  const [potentialStatus, setPotentialStatus] = useState<any>(false);
  const [potentialValue, setPotentialValue] = useState<any>("");
  const [potentialEditValue, setPotentialEditValue] = useState<any>("");
  const [isAnalysisValue, setIsAnalysisValue] = useState<any>("");

  useEffect(() => {
    {
      folderResponseData.map((item: any) => {
        if (selectScenario === item.scenario) {
          setPotentialEditValue(item?.potentialLocations);
          setIsAnalysisValue(item?.isAnalysis);
        }
      });
    }
  }, [folderResponseData, selectScenario]);

  const handleEditClick = () => {
    setPotentialStatus(true);
  };

  const handlePotentialChange = (val: any) => {
    setPotentialValue(val.target.value);
  };

  const handleCancel = () => {
    setPotentialStatus(false);
  };

  const handleSave = () => {
    const urls = API_BASE_URL + CGO_Location_EDIT_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    const params = {
      id: 0,
      folder_Id: selectedFolderId,
      scenario_Id: selectedScenarioId,
      potentialLocation: Number(potentialValue),
      isAnalysis: isAnalysisValue,
      isUpload: true,
    };
    putRequest(urls, params, header, {})
      .then((response) => {
        if (response.status === 200) {
          // setMessage("Success!");
          // handleClose();
          // dispatch(EditProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        // setMessage(error);
      });
    setPotentialStatus(false);
  };
  const handleCloseUploadCGONow = () => {
    setIsUploadNowPopup(false);
  };
  const handleDoneUpload = (status: any) => {
    if (status === 200) {
      setIsUploadNowPopup(false);
      setIsUploadNowSuccess(true);
      setTimeout(() => {
        setIsUploadNowSuccess(false);
      }, 3000);
    }
  };

  //editscenairo popup

  const handleAllowEdit = () => {
    setOpenForEdit(false);
    dispatch(enableEditPopupForSave(true)); // for displaying save button for edit
  };

  const handleNotAllowEdit = () => {
    setOpenForEdit(false);
    dispatch(enableEditFilter(false, "handleStopEdit")); // not allow for edit
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [modalTitleText, setModalTitleText] = useState<any>(
    "Select/Create Folder & Add Scenario",
  );
  const [inputFolderName, setInputFolderName] = useState("");
  const [inputFolderId, setInputFolderId] = useState("");
  const [isViewExistingScenario, setIsViewExistingScenario] = useState(false);

  const handleNextInputData = (selectedData: any) => {
    let folderSelected = selectedData;
    let folder_id = folderSelected.id;
    setInputFolderName(folderSelected.folder);
    setInputFolderId(folder_id);
    // Selected Folder API call
    dispatch(displayFolderList());
    const urls = API_BASE_URL + SELECTED_DISPLAY_FOLDER_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(urls, { folder_id: folder_id }, header)
      .then((response) => {
        // getRequest(urls + "?folder_id =" + folder_id,{}, header).then((response) => {
        if (response.status === 200) {
          dispatch(selectedUploadFolderListSuccess(response.data?.data));
          //dispatch(selectedFolderListSuccess(response.data?.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(selectedFolderListError(error));
      });
  };

  return (
    <>
      {uploadReRunStatus && (
        <Modal
          open={uploadReRunStatus}
          onClose={handleReRunDialogStatus}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
          className="done-modal"
          ref={modelRef}
          onClick={handleBackDropClick}
        >
          <>
            <DialogContent data-keyboard="false" data-backdrop="static">
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 600,
                  bgcolor: "background.paper",
                  border: "2px solid #000",
                  boxShadow: 24,
                  p: 4,
                  height: 400,
                  // overflowY: 'auto'
                }}
              >
                <Box>
                  <p>
                    {(reRunDialogStatus
                      ?.toLowerCase()
                      ?.includes("successfully") ||
                      reRunDialogStatus?.toLowerCase()?.includes("failed")) && (
                      <>
                        <CancelIcon
                          className="cancel-icon"
                          onClick={handleReRunDialogStatus}
                        />

                        {/* <a onClick={handleClosePopup}>Close</a> */}
                      </>
                    )}
                  </p>
                  {reRunloading && (
                    <Box>
                      <div
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <CircularProgress />
                      </div>
                    </Box>
                  )}

                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>File Name</TableCell>
                          <TableCell>File Status</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rerunUploadStatusData?.map((item: any) => (
                          <TableRow>
                            <TableCell>{item.fileName}</TableCell>
                            <TableCell>{item.status}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                {openReRunDialogStatus
                  ?.toLowerCase()
                  ?.includes("successfully") ? (
                  <>
                    <h6>{openReRunDialogStatus}</h6>
                    <br />
                  </>
                ) : openReRunDialogStatus?.toLowerCase()?.includes("failed") ? (
                  <>
                    <h6 className="error-modal-message">
                      {openReRunDialogStatus}
                    </h6>
                    <br />
                    {/* <a onClick={handleClosePopup}>Close</a> */}
                  </>
                ) : (
                  <>{/* <p> props?.doneMessage</p>  */}</>
                )}

                <div style={{ alignItems: "center", textAlign: "center" }}>
                  {/* <Button onClick={handleReRunDialogStatus}>Close</Button> */}
                </div>
              </Box>
            </DialogContent>
          </>
        </Modal>
      )}
      {isUploadNowSuccess && (
        <ToastPopup message={"Files Uploaded Successfully"} type="success" />
      )}
      <BootstrapDialog
        onClose={handleCloseUploadCGONow}
        aria-labelledby="customized-dialog-title"
        open={isUplodNowPopup}
        className="small-modal-popup"
      >
        <div className="modal-header">
          <Grid container spacing={1}>
            <Grid item xs={10} md={10} lg={10}>
              <h3>{modalTitleText}</h3>
            </Grid>
            <Grid item xs={2} md={2} lg={2}>
              <CancelIcon
                className="cancel-icon"
                onClick={handleCloseUploadCGONow}
              />
            </Grid>
          </Grid>
        </div>
        <DialogContent>
          <CGOInputModal
            setModalTitleText={setModalTitleText}
            handleNextInputData={handleNextInputData}
            handleGoBack={closeUploadModal}
            handleClose={props.onClose}
            handleUploadNow={props?.handleUploadNow}
            selectRadio={selectRadio}
            isSelectedScenarios={selectScenario ? true : false}
            selectedFolderId={selectedFolderId}
            selectedScenarioId={selectedScenarioId}
          />
        </DialogContent>
      </BootstrapDialog>
      {/* {true && (
      <Loader/>
    )} */}
      {isErrorOrWarningDialog && (
        // eslint-disable-next-line react/jsx-no-undef
        <ErrorOrWarningDialog
          isErrorOrWarningDialog={isErrorOrWarningDialog}
          errorOrWarningMessage={errorOrWarningMessage}
        />
      )}

      {isErrorDialog && (
        <ErrorDialog
          isErrorDialog={isErrorDialog}
          errorMessage={errorMessage}
        />
      )}

      {isBaseLineUploader && (
        <BaseLineUploading
          isOpenBaseLineUploader={isBaseLineUploader}
          handleOpenBaseLineUploader={handleOpenBaseLineUploader}
          closeBaseLineUploader={closeBaseLineUploader}
        />
      )}

      {isEditFileStatus && (
        <Modal
          open={isEditFileStatus}
          onClose={handleReRunDialog}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              border: "2px solid #000",
              boxShadow: 24,
              p: 4,
            }}
          >
            <h2
              style={{ alignItems: "center", textAlign: "center" }}
              id="modal-title"
            >
              Please Re-Run!
            </h2>
            <div style={{ alignItems: "center", textAlign: "center" }}>
              <Button onClick={handleReRunDialog}>Close</Button>
            </div>
          </Box>
        </Modal>
      )}

      {openReRunDialog && (
        <Modal
          open={openReRunDialog}
          onClose={handleCloseReRunDialog}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
          data-keyboard="false"
          data-backdrop="static"
        >
          <>
            <DialogContent data-keyboard="false" data-backdrop="static">
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 400,
                  bgcolor: "background.paper",
                  border: "2px solid #000",
                  boxShadow: 24,
                  p: 4,
                }}
              >
                <h3>{reRunStatus}</h3>

                <div style={{ alignItems: "center", textAlign: "center" }}>
                  <Button onClick={handleCloseReRunDialog}>Close</Button>
                </div>
              </Box>
            </DialogContent>
          </>
        </Modal>
        // <Loader />
      )}

      {duplicateScenario && (
        <DuplicateScenario
          isOpen={duplicateScenario}
          cancelDuplicate={cancelDuplicate}
          folderItems={CGOFolderOptions}
          useCaseId={selectedUsecaseeId}
          categoryId={selectedCategoryId}
        />
      )}
      {isOpenUploadModal && (
        <UploadModal
          isOpen={isOpenUploadModal}
          onClose={closeUploadModal}
          isNext={isNext}
          selectRadio={selectRadio}
          isUploadScenarioData={isUploadScenarioData}
          handleChangeRadio={handleChangeRadio}
          handleNext={handleNext}
          handleGoBack={handleGoBack}
          handleCloseDonePopup={handleCloseDonePopup}
          handleOpenBaseLineUploader={handleOpenBaseLineUploader}
          handleUploadNow={(e: any) => handleUploadNow(e, "uploadnow")}
          // handleTemplateDownLoad={handleTemplateDownLoad}
          handleBack={handleBack}
          isUploadMasterFile={isUploadMasterFile}
          hiddenFileInput={hiddenFileInput}
          handleCancelFile={handleCancelFile}
          handleUploadFile={handleUploadFile}
          handleChangeFileUpload={handleChangeFileUpload}
          getData={
            selectRadio === "inputData" ? getInputLineData : getMasterData
          }
          selectedfile={selectedfile}
          isUploadBaseLineData={isUploadBaseLineData}
          selectLine={scenarioAnalysys?.toString()}
        />
      )}
      <div className="filter-component">
        <div>
          <div className="grid-layout">
            <div className="four-column">
              <FormControl fullWidth className="selectDropdown">
                <Select
                  id="simple-select-4"
                  value={selectFolder}
                  placeholder="Select Folder"
                  onClick={handleClickSelectFolder}
                  onChange={handleChangeSelectFolder}
                  renderValue={(selected: any) => selected}
                  className="select-short-term"
                >
                  {sortedFolderNames?.map((d: any) => {
                    return (
                      <MenuItem key={d.id} value={d}>
                        {d.folder}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="four-column">
              <FormControl fullWidth>
                <Select
                  id="simple-select-4"
                  value={selectScenario}
                  placeholder="Scenario"
                  onClick={handleClickSelectScenario}
                  onChange={handleChangeSelectScenario}
                  renderValue={(selected: any) => selected}
                  className="select-short-term"
                >
                  {CGOScenarioOptions.map((d: any) => {
                    return (
                      <MenuItem key={d?.scenario_id} value={d}>
                        {d?.scenario}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            <div
              className={
                selectedFolderId && selectedScenarioId && canEditScenario
                  ? "download-btn"
                  : "disable-download-btn"
              }
              onClick={() => handleGurobiDownload()}
            >
              <img src={DownloadIcon} alt="" /> <span> Download Data</span>
            </div>

            <div
              className={
                selectedFolderId && selectedScenarioId && canEditScenario
                  ? "upload-btn"
                  : "disabled-upload-btn"
              }
              onClick={handleUploadData}
            >
              <img src={UploadIcon} alt="" /> <span> Upload Data</span>
            </div>
          </div>
        </div>
        <div className="clear"></div>
      </div>

      {showFullOverlay && (
        <div className="firstthingfirstInfo">
          <div className="arrow-icon">
            <img src={arrowIcon} alt="" />
          </div>
          <div>
            <span>
              {" "}
              <img src={excelIcon} alt="" />
            </span>
            <span className="title">First Things First!</span>
          </div>
          <br></br>
          <div>
            You need to add your master and Input data files to start creating
            optimizations.
          </div>
          <br></br>
          <div className="footer-links">
            <span>
              <a
                href="#"
                onClick={(e) => {
                  e.stopPropagation();
                  setfullOverlayDetails(false);
                }}
              >
                Skip
              </a>
            </span>
            <span>To Explore app</span>
          </div>
        </div>
      )}
      {showFullOverlay && <div className="download-overlay"></div>}

      <div className="baseline-actions-cog">
        <div className="grid-layout1">
          <div className="half-column">
            <table cellSpacing={0} cellPadding={0}>
              <tr>
                <td style={{ width: "240px" }}>
                  <span>
                    <h6 className="costLabel">Weighted Distance</h6>
                  </span>
                  <span>
                    <Tooltip title="Scenario">
                      <InfoIcon className="infoIcon" />
                    </Tooltip>
                  </span>
                </td>
                <td>
                  <span>
                    <h6 className="costLabel">Potential Locations</h6>
                  </span>
                  <span>
                    <Tooltip title="Scenario">
                      {isEditEnabled === true ? (
                        <EditIcon
                          className="editIcon"
                          onClick={handleEditClick}
                          style={{ cursor: "pointer" }}
                        />
                      ) : (
                        <EditIcon
                          className="infoIcon"
                          style={{ cursor: "pointer" }}
                        />
                      )}
                    </Tooltip>
                  </span>
                  {potentialStatus && (
                    <span>
                      <a
                        style={{
                          color: "green",
                          cursor: "pointer",
                          marginLeft: "10px",
                        }}
                        onClick={handleSave}
                      >
                        Save
                      </a>
                      <a
                        style={{
                          color: "red",
                          cursor: "pointer",
                          marginLeft: "5px",
                        }}
                        onClick={handleCancel}
                      >
                        Cancel
                      </a>
                    </span>
                  )}
                </td>
              </tr>
              <tr>
                <td>
                  {" "}
                  <p className="costValue" style={{ color: "black" }}>
                    {scenarioCost}
                  </p>
                </td>
                <td>
                  {" "}
                  <p className="costValue" style={{ color: "black" }}>
                    {potentialStatus ? (
                      <TextField
                        id="outlined-basic"
                        placeholder="Potential Locations"
                        className="create-folder-text"
                        variant="outlined"
                        value={potentialValue}
                        onChange={handlePotentialChange}
                      />
                    ) : (
                      potentialValue
                    )}
                  </p>
                </td>
              </tr>
            </table>

            {/* <p className="costValue" style={{ color: "#FF2828" }}> */}
          </div>
          <div className="half-column">
            <table className="pull-right">
              <tr>
                <td>
                  <div className="flex-display">
                    {canEditScenario &&
                    selectedUsecaseId > 0 &&
                    selectedCategoryId > 0 &&
                    selectedFolderId > 0 &&
                    selectedScenarioId > 0 ? (
                      <>
                        {
                          <>
                            <Grid className="Duplicatescenario">
                              <div
                                className="scenario-btns"
                                onClick={handleOpenDuplicateScenario}
                              >
                                <img src={DuplicateIcon} alt="" />
                                <span>Duplicate Scenario</span>
                              </div>
                            </Grid>
                            <Grid
                              className={
                                isEditEnabled === false
                                  ? "Duplicatescenario"
                                  : "Duplicatescenario Duplicatescenario-disabled"
                              }
                            >
                              <div
                                className="scenario-btns"
                                {...(isEditEnabled === false && {
                                  onClick: handleEdit,
                                })}
                              >
                                <img src={EditScenario} alt="" />
                                <span>Edit Scenario</span>
                              </div>
                            </Grid>
                          </>
                        }
                      </>
                    ) : (
                      <>
                        <Grid className="Duplicatescenario Duplicatescenario-disabled">
                          <div
                            className="scenario-btns"
                            onClick={handleOpenDuplicateScenario}
                          >
                            <img src={DuplicateIcon} alt="" />
                            <span>Duplicate Scenario</span>
                          </div>
                        </Grid>
                        <Grid className="Duplicatescenario Duplicatescenario-disabled">
                          <div className="scenario-btns">
                            <img src={EditScenario} alt="" />
                            <span className="rerun">Edit Scenario</span>
                          </div>
                        </Grid>
                      </>
                    )}

                    {
                      <>
                        <Grid className="Duplicatescenario Duplicatescenario-disabled">
                          <div
                            className={
                              isEditEnabled ? "scenario-btns" : "scenario-btns1"
                            }
                            {...(isEditEnabled && { onClick: handleRerun })}
                          >
                            <img src={ReRun} alt="" />
                            <span>Re-Run</span>
                          </div>
                        </Grid>
                      </>
                    }
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      {isEditEnabled && (
        <Dialog
          fullScreen={fullScreen}
          open={openForEdit}
          onClose={() => setOpenForEdit(false)}
          aria-labelledby="responsive-dialog-title"
          className="Dialogbox-display"
        >
          <DialogTitle
            id="responsive-dialog-title"
            className="responsive-dialog-title-txt"
          >
            {"Confirmation for Edit"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText className="md-alert-clr">
              Are you sure you want to edit the scenario?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              className="modal-btn-b"
              onClick={handleNotAllowEdit}
              autoFocus
            >
              No
            </Button>
            <Button className="modal-btn-b" autoFocus onClick={handleAllowEdit}>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}

export default CGOFilterComponent;
function selectedUseCaseSuccess(value: any): any {
  throw new Error("Function not implemented.");
}
